"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchComponentData = exports.ComponentDataProvider = void 0;
exports.fetchLanguageAndComponentFeatureRules = fetchLanguageAndComponentFeatureRules;
exports.useComponentDataProvider = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@site/utils");
var _domainServices = require("@site/domain-services");
var _spinner = _interopRequireDefault(require("@ux/spinner"));
var _UipDataProvider = require("./UipDataProvider");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { init } from '@site/elastic-apm';

// const serverUrl = {
//   dev: 'https://f511d374c86b4c4580049a081a35cf1d.apm.us-west-2.aws.cloud.es.io:443',
//   test: 'https://f511d374c86b4c4580049a081a35cf1d.apm.us-west-2.aws.cloud.es.io:443',
//   local: 'https://f511d374c86b4c4580049a081a35cf1d.apm.us-west-2.aws.cloud.es.io:443',
//   prod: 'https://e602a0de7e604ec0a43ac13c9dbb35e8.apm.us-west-2.aws.cloud.es.io:443'
// };

const ComponentDataContext = /*#__PURE__*/_react.default.createContext();
async function fetchLanguageAndComponentFeatureRules(params, extraParams, queryParams, errorCallback = () => {}) {
  const {
    env
  } = params;
  const {
    apiKey
  } = extraParams;
  const market = (0, _utils.getCookie)('market') || 'en-US';
  const {
    getDomainSearchComponentBFFApi
  } = new _domainServices.DomainServices({
    apiKey,
    env,
    market,
    fetchEntity: global.fetch
  });
  const locale = (0, _utils.getLocaleFromMarket)(market);
  try {
    const response = await getDomainSearchComponentBFFApi({
      extraParams,
      queryParams: {
        ...queryParams,
        locale,
        version: 'v2'
      }
    });
    return response;
  } catch (error) {
    errorCallback?.(error);
  }
}
const fetchComponentData = async ({
  params,
  extraParams,
  queryParams = {},
  componentName,
  market
}) => {
  if (window && Object.keys(window).includes(componentName) && market === window.market) {
    return window[`${componentName}`];
  }
  const {
    componentFeatureRules = {},
    language = {}
  } = await fetchLanguageAndComponentFeatureRules(params, extraParams, queryParams);
  const componentOverrideProps = componentFeatureRules.variants?.[componentName]?.data || {};
  const componentStrings = language || {};
  if (window) {
    window[`${componentName}`] = {
      componentOverrideProps: componentOverrideProps,
      componentStrings: componentStrings
    };
  }
  return {
    componentOverrideProps: componentOverrideProps,
    componentStrings: componentStrings
  };
};
exports.fetchComponentData = fetchComponentData;
const ComponentDataProvider = ({
  children,
  appName = '',
  componentName = '',
  apiKey = '',
  forceEnableBFF,
  uipProps = {},
  loader = /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: "md"
  })
}) => {
  const [apm] = (0, _react.useState)();
  const [bffValues, setBFFValues] = (0, _react.useState)();
  if (!appName) {
    throw new Error(`${componentName} is missing required prop appName`);
  }

  // Temporary disable APM initialization, Jira ticket to re-enable: https://godaddy-corp.atlassian.net/browse/FIND-7280

  // useEffect(() => {
  //   if (!apm && !window.Cypress) {
  //     const url = window.location.href;
  //     const env = getEnv(url);
  //     try {
  //       const apmInstance = init({
  //         serviceName: componentName,
  //         serverUrl: serverUrl[env] || serverUrl.prod,
  //         environment: env,
  //         serviceVersion: '0',
  //         active: true,
  //         instrument: true,
  //         usePrivateApm: true,
  //         disableInstrumentations: ['eventtarget']
  //       });

  //       apmInstance.addLabels({
  //         appName,
  //         componentName,
  //         url
  //       });

  //       setApm(apmInstance);
  //     } catch {
  //       throw Error('APM initialization failed');
  //     }
  //   }
  // }, [apm]);

  // call BFF API
  (0, _react.useEffect)(() => {
    async function getComponentFeatureRulesAndLanguage() {
      const urlParams = new URLSearchParams(window.location.search);
      const verification = urlParams.get('verification');
      const assetSha = urlParams.get('assetSha');
      const ignoreHivemind = urlParams.get('ignoreHivemind');
      const enableBFF = urlParams.get('enableBFF') || forceEnableBFF;
      const url = window.location.href;
      const market = (0, _utils.getCookie)('market') || 'en-US';
      const env = (0, _utils.getEnv)(url);
      const extraParams = {
        apiKey,
        appName,
        componentName
      };
      const params = {
        env
      };
      const queryParams = {
        ...(verification && {
          verification
        }),
        ...(assetSha && {
          assetSha
        }),
        ...(ignoreHivemind && {
          ignoreHivemind
        })
      };
      enableBFF ? setBFFValues(await fetchComponentData({
        params,
        extraParams,
        queryParams,
        componentName,
        market
      })) : setBFFValues({
        componentOverrideProps: {},
        componentStrings: {}
      });
    }
    getComponentFeatureRulesAndLanguage();
  }, []);
  const overrideProps = bffValues?.componentOverrideProps;
  const languageStrings = bffValues?.componentStrings;
  return overrideProps || languageStrings ? /*#__PURE__*/_react.default.createElement(ComponentDataContext.Provider, {
    value: {
      apm,
      overrideProps,
      languageStrings
    }
  }, uipProps ? /*#__PURE__*/_react.default.createElement(_UipDataProvider.UipDataProvider, (0, _extends2.default)({}, uipProps, {
    insightTypes: [uipProps.insightType]
  }), children) : children) : loader;
};
exports.ComponentDataProvider = ComponentDataProvider;
ComponentDataProvider.propTypes = {
  children: _propTypes.default.node.isRequired,
  appName: _propTypes.default.string.isRequired,
  componentName: _propTypes.default.string.isRequired,
  apiKey: _propTypes.default.string.isRequired,
  forceEnableBFF: _propTypes.default.bool,
  uipProps: _propTypes.default.object,
  loader: _propTypes.default.element
};
const useComponentDataProvider = languageProp => {
  const {
    apm,
    overrideProps = {},
    languageStrings = {}
  } = (0, _react.useContext)(ComponentDataContext) || {};
  const mergedLanguage = {
    ...languageStrings,
    ...languageProp
  };
  return {
    apm,
    overrideProps,
    languageStrings: mergedLanguage
  };
};
exports.useComponentDataProvider = useComponentDataProvider;